export type { PayloadAction } from '@reduxjs/toolkit';
import * as toolkit from '@reduxjs/toolkit';

// redux-toolkit provides an ESM module, but in way that webpack understands but Node.js does not.
// See https://github.com/reduxjs/redux-toolkit/issues/1960

export const { configureStore, createSlice } = ((toolkit as any).default ??
  toolkit) as typeof toolkit;
